export default __webpack_public_path__ + "static/media/venhancer-before.b1440d20.png";